import { BankInstitution } from "@/common/types/bankInstitution.type";

export class BankInstitutionsTransformer {
  static optionsTransformer() {
    return (BankInstitutions: BankInstitution[]) => {
      return BankInstitutions.map((BankInstitution) => {
        return {
          value: BankInstitution.id,
          label: `${BankInstitution.code} - ${BankInstitution.name}`,
        };
      });
    };
  }
}
